import { useStytchMemberSession } from '@stytch/nextjs/b2b'

export const useStytchB2BSession = useStytchMemberSession
